module.exports = __webpack_public_path__ + "img/doctor_icon.28a0e57b.jpeg";